import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import tw from "tailwind-styled-components";
import { SIcon } from "../components";
const SpinnerOverlay = tw.div`
  flex
  justify-center
  items-center
  absolute
  top-0
  left-0
  bg-[#121316AA]
  w-full
  h-full
`;
const Spin = tw.div`
  relative  
  animate-spin
`;
const SSpinner = ({ size = "md", color = "currentColor" })=>{
    return /*#__PURE__*/ _jsx(Spin, {
        children: /*#__PURE__*/ _jsx(SIcon, {
            type: "spinner",
            size: size,
            color: color
        })
    });
};
const SOverlaySpinner = ({ size = "md", overlayColor = "rgba(0,0,0,0)", color = "currentColor" })=>{
    return /*#__PURE__*/ _jsx(SpinnerOverlay, {
        style: {
            background: overlayColor
        },
        children: /*#__PURE__*/ _jsx(SSpinner, {
            color: color,
            size: size
        })
    });
};
export { SSpinner, SOverlaySpinner };
